import { StylesConfig } from 'react-select';
import styled from 'styled-components';
import { trioUITheme } from '@/styles/theme';
import { DropdownOption } from './AutoCompleteDropdown';

type InputStyleType = {
  isLabelAboveField?: boolean;
  darkerLabel?: boolean;
};

export const Label = styled.p<InputStyleType>`
  font-size: 14px;
  display: block;
  line-height: 21px;
  min-height: 21px;
  color: ${(props) =>
    props.darkerLabel ? props.theme.colors['neutral-90'] : props.theme.colors['neutral-80']};
`;

export const Box = styled.div`
  position: relative;

  svg {
    width: 10px;
  }

  [class$='-control'] {
    &:hover {
      border-color: ${({ theme }) => theme.colors['neutral-40']};
    }

    &:has(input:focus) {
      border-color: ${({ theme }) => theme.colors['secondary-60']};
    }
  }

  [class$='-IndicatorsContainer'] > div:first-child {
    background-color: ${({ theme }) => theme.colors['neutral-30']};
    border-radius: 50%;
    padding: 1px;
    cursor: pointer;

    &:hover {
      background-color: ${({ theme }) => theme.colors['neutral-40']};
    }

    svg {
      width: 10px;
      height: 10px;
      color: white;
    }
  }

  div[role='button'] {
    svg {
      width: 14px;
      color: #6f7175;
    }
  }

  [class$='-Input'] {
    &::after,
    & > input {
      height: 19px;
    }
  }
`;

function setFontSize(styles): any {
  return {
    ...styles,
    fontSize: '14px',
  };
}

export const customComponentStyles: StylesConfig<DropdownOption, boolean> = {
  control: (styles) => ({
    ...styles,
    minHeight: '38px',
    borderColor: trioUITheme.colors['neutral-30'],
    borderRadius: '6px',
    boxShadow: 'none',
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: '5.5px 0 5.5px 12px',
    gap: 6,
  }),
  clearIndicator: (styles) => ({
    ...styles,
    padding: 0,
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    color: trioUITheme.colors['neutral-100'],
    padding: '0 16px 0 6px',
    cursor: 'pointer',
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    paddingLeft: 6,
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    display: 'none',
  }),
  input: (styles) => ({
    ...setFontSize(styles),
    margin: 0,
    padding: 0,
    cursor: 'text',
  }),
  placeholder: (styles) => ({ ...setFontSize(styles), margin: 0, lineHeight: '19px' }),
  singleValue: (styles) => ({ ...setFontSize(styles), height: '15px', lineHeight: '14px' }),
  option: (styles) => setFontSize(styles),
  multiValue: (styles) => ({
    ...styles,
    // padding: '3px 6px',
    margin: 0,
    borderRadius: 4,
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    paddingVertical: '3px',
    paddingLeft: 6,
    fontSize: '12px',
    lineHeight: '14px',
  }),
  menuPortal: (styles) => ({
    ...styles,
    paddingTop: 0,
    paddingBottom: 0,
    borderColor: 'red',
  }),
  menu: (styles) => ({
    ...styles,
    borderRadius: 8,
    marginTop: 4,
    marginBottom: 0,
    border: `1px solid ${trioUITheme.colors['neutral-30']}`,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    backgroundColor: trioUITheme.colors['neutral-0'],
  }),
  menuList: (styles) => ({
    ...styles,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
  }),
};
